import React, {
    Component
} from 'react'
import {
    Form,
    Row,
    Col,
    Input, InputNumber, Select, Checkbox,
    Button, Table, Popconfirm, Modal, Radio,
    Icon, Card,
    Collapse
} from 'antd';
import { uuid } from '../../common/CommonFunc'
import { UserModal } from '../../common/UserModal'
import  PubInfo  from '../../Component/PubInfo'
const FormItem = Form.Item;
const Panel = Collapse.Panel;
const Option = Select.Option;
const CheckboxGroup = Checkbox.Group;
const RadioGroup = Radio.Group;

class JumpNodeFrom extends Component {
    constructor(props) {
        super(props)

        this.state = {
            node: props.node,
            show: props.show != null && props.show == true ? props.show : 'none',
            nodedata: props.nodedata,

            loading: false
        }
    }

    // 重新加载页面方法
    reload = () => {
        this.setState({ loading: false });
    }
    // 文本修改事件
    textOnChange(attname, e, e2) {
        tool.sgiLogger.log("事件：textOnChange")
        let value = e.target.value;
        this.refresh(attname, value);
    }
    // 下拉窗修改事件
    selectOnChange = (attname, value) => {//change传入对象为value
        tool.sgiLogger.log("事件：selectOnChange")
        this.refresh(attname, value);
    }
    // 复选框组修改事件，checkedValue为数组["01","02"]
    checkboxGroupOnChange = (attname, checkedValue) => {
        tool.sgiLogger.log("事件：checkboxGroupOnChange")
        this.refresh(attname, checkedValue);
    }
    // 单选框组修改事件
    radioGroupOnChange(attname, e) {
        tool.sgiLogger.log("事件：radioGroupOnChange")
        let value = e.target.value;
        this.refresh(attname, value);
    }
    // 数字组件修改事件
    numberOnChange(attname, e) {
        let value = e;
        this.refresh(attname, value);
    }
    // 属性更新
    refresh(attname, value) {
        if (attname === 'name' && this.state.nodedata[attname] != value) this.state.node.setText(this.state.node.data.id+" "+value);
        this.state.nodedata[attname] = value;
    }

    // 表格添加方法
    handleAdd = (modalType) => {
        tool.sgiLogger.log("handleAdd表格添加方法");
        if (!modalType || modalType == '') {
            this.state.modalContent = null;;
        }
        if (modalType == 'human') {
            this.state.modalContent = <UserModal key={uuid(8)} modalShow={true} title="选择操作人员"
                approvalUserList={this.state.nodedata.human} parent={this} />
        }
        this.setState({
            loading: false
        });
    }
    // 表格删除方法
    handleDelete = (delData, dataSource) => {
        if (dataSource && delData) {
            for (var i = 0; i < dataSource.length; i++) {
                if (delData == dataSource[i] || delData._key == dataSource[i]._key) {
                    dataSource.splice(i, 1);
                }
            }
        }
        this.setState({ loading: false });
    }
    // 创建表格绑定store（生成数据key）
    getTBData = (tData) => {
        if (!tData) {
            tData = [];
            return tData;
        }
        tData.forEach(element => {
            if (!element._key) element._key = uuid(8);
        })
        return tData;
    }

    // 刷新form
    componentDidMount() {
        tool.sgiLogger.log('事件：jumpNode加载后')
        this.props.form.setFieldsValue({
            ncode: this.props.nodedata.ncode,

            ishuman: this.state.nodedata.ishuman,
            receiveTimeoutHandling: this.state.nodedata.receiveTimeoutHandling,
            // interventionUsers: this.state.nodedata.interventionUsers

        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        const human = this.getTBData(this.state.nodedata.human);
        const interventionUserListColumns = [
            {
                title: '用户名称', // 列头显示名称
                dataIndex: 'empName' // 列数据在数据项中对应的 key
            },
            {
                title: '操作',
                key: 'action',
                render: (text, record) => (
                    this.state.nodedata.human.length >= 1
                        ? (
                            <Popconfirm title="确认删除?" onConfirm={() => this.handleDelete(record, this.state.nodedata.human)}>
                                <a href="javascript:;">删除</a>
                            </Popconfirm>
                        ) : null
                ),
            }
        ];

        return (
            <div>
                <Form layout="vertical" >
                    <Collapse defaultActiveKey={['1']} >
                        <Panel header="通用节点信息" key="1">
                            <PubInfo parent={this} node={this.state.node} nodedata={this.state.nodedata} />
                        </Panel>
                        <Panel header="跳转节点信息" key="2">
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item label="目标节点编号">
                                        {getFieldDecorator('ncode', {
                                            rules: [{ required: true, message: '请链接目标节点' }],
                                        })(
                                            <Input placeholder="请链接目标节点" readOnly
                                                onChange={this.textOnChange.bind(this, 'ncode')}
                                            />
                                        )}
                                       双击虚线修改跳转目标节点
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Panel>
                        <Panel header="干预策略" key="4" >
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Form.Item label="人工干预">
                                        {getFieldDecorator('ishuman', {
                                            rules: [{ required: false, message: '' }],
                                        })(
                                            <RadioGroup onChange={this.radioGroupOnChange.bind(this, 'ishuman')} >
                                                <Radio value={"0"}>不允许</Radio>
                                                <Radio value={"1"}>允许</Radio>
                                            </RadioGroup>
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
							{this.state.nodedata.ishuman == "1" ?
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Form.Item label="处理规则">
                                        {getFieldDecorator('handling', {
                                            rules: [{ required: false, message: '' }],
                                        })(
                                            <CheckboxGroup onChange={this.checkboxGroupOnChange.bind(this, 'handling')} >
                                                <Checkbox value={"01"}>完成节点</Checkbox>
                                                <Checkbox value={"02"}>回退处理</Checkbox>
                                            </CheckboxGroup>
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>:""}
							{this.state.nodedata.ishuman == "1" ?
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Button size="small" onClick={this.handleAdd.bind(this, "human")} type="primary" style={{ marginBottom: 10 }}>
                                        添加操作人员
									</Button>
                                    <Table size="small" rowKey={"_key"}
                                        rowClassName={() => 'userList-row'} // 表格行的类名
                                        bordered // 是否展示外边框和列边框
                                        dataSource={human}
                                        columns={interventionUserListColumns}
                                    />
                                </Col>
                            </Row>
							:""}
                        </Panel>
                    </Collapse>
                </Form>
                {this.state.modalContent}
            </div>
        )
    }
}

const JumpNode = Form.create()(JumpNodeFrom);
export default JumpNode;


// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiFlow/Workflow/Component/JumpNode.js